// Header details for LessonView — shared by the student lesson page and the
// teacher's "Student view" preview, so both always show the same thing.

export const HERO_TOPIC_LIMIT = 4;

/**
 * When the session first went live (ISO string), or null if it never has.
 * Both the student lesson API and the teacher's draft API send
 * `first_published_at`; `published_at` can move on a republish.
 */
export function firstPublishedAt(lesson) {
  return lesson?.first_published_at || null;
}

/**
 * Section chips under the title: the first few, plus whether to end with "…"
 * because the lesson has more than are listed.
 */
export function heroTopics(keyTopics, totalSections) {
  const topics = keyTopics || [];
  const shown = topics.slice(0, HERO_TOPIC_LIMIT);
  if (shown.length === 0) return { shown, hasMore: false };
  return { shown, hasMore: topics.length > shown.length || totalSections > shown.length };
}
